//#region src/exactly-one-form.ts
/**
* Adds one custom issue to `ctx` when `value` carries neither or both of `ageKey` and `instantKey`.
*
* Inputs: `value` is the parsed object (a key that is `undefined` counts as absent). `subject` names
* the row in the message, for example `an unsatisfiedDemand row`. `ageKey` and `instantKey` are the
* two key names.
*
* Output: nothing when exactly one key is present. Otherwise one issue with `code: 'custom'`, the
* path of the object itself (`path: []`), and the message
* `<subject> carries exactly one of <ageKey> and <instantKey>; this one carries neither` (or `both`).
* The CP 400 body and the operator log read that message, so its text is part of the contract.
*
* Side effects: the one `ctx.addIssue` call. Throws nothing.
*/
function refineExactlyOneForm(value, ctx, subject, ageKey, instantKey) {
	const forms = (value[ageKey] === void 0 ? 0 : 1) + (value[instantKey] === void 0 ? 0 : 1);
	if (forms !== 1) ctx.addIssue({
		code: "custom",
		path: [],
		message: `${subject} carries exactly one of ${ageKey} and ${instantKey}; this one carries ${forms === 0 ? "neither" : "both"}`
	});
}
//#endregion
export { refineExactlyOneForm };

//# sourceMappingURL=exactly-one-form.js.map